import React from 'react';
import Navbar from '../../components/Navbar';
import { Link } from 'react-router-dom';
import './Services.css';

const Services = () => {
  return (
    <div className="services-page">
      <Navbar />
      <div className="services-container">
        <h1>Our Services</h1>
        <div className="services-content">
          <div className="try-product-section">
            <div className="service-icon">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 7.5L12 2L3 7.5M21 7.5V16.5L12 22L3 16.5V7.5M21 7.5L12 13L3 7.5M12 13V22" stroke="#3498db" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <h2>Try Our AI CAD Copilot</h2>
            <p>
              Experience the future of CAD modeling with our AI-powered solution.
              Simply describe what you want to create, and our AI will generate a
              production-ready 3D model instantly.
            </p>
            <div className="button-container">
              <Link to="https://app.pixelateinc.com/">
                <button className="cta-button">Start Building with AI</button>
              </Link>
            </div>
          </div>

          <div className="survey-section">
            <div className="service-icon">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15M9 5C9 6.10457 9.89543 7 11 7H13C14.1046 7 15 6.10457 15 5M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5M12 12H15M12 16H15M9 12H9.01M9 16H9.01" stroke="#3498db" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </div>
            <h2>Help Us Improve</h2>
            <p>
              We value your feedback! Take our quick survey to help us improve our
              product and get a chance to win a $15 gift card.
            </p>
            <div className="button-container">
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSfpJ0dFF2edps07ev_XveJslB9DdthGkjIVsXGoNCil0wUTqA/viewform?usp=dialog"
                target="_blank"
                rel="noopener noreferrer"
                className="survey-button"
              >
                Take Survey
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services; 